// @flow

export function translateErrorMessageES(errorCode: string): ?string {
  switch (errorCode) {
    case 'CI-000':
    case 'BP-DR-112':
      return 'Por favor, utilice otra tarjeta, o seleccione otro método de pago.';
    case 'IT-500':
      return 'Comprueba tu conexión a Internet y vuelve a intentarlo.';
    case 'PR-001':
      return 'Su pago no ha sido aprobado. Revise sus datos o elija otro método de pago.';
    case 'BP-R-32':
      return 'Esta compra es mayor que el límite permitido para las compras realizadas en EBANX.';
    case 'BP-DR-6':
      return 'Este método de pago no está disponible para el valor de su compra. Seleccione otro método de pago.';
    case 'BP-DR-7':
      return 'Este método de pago no está disponible para el valor de su compra. Seleccione otro método de pago.';
    case 'BP-DR-13':
      return 'Nombre es requerido.';
    case 'BP-DR-15':
      return 'El e-mail es requerido.';
    case 'BP-DR-17':
      return 'El E-mail informado es inválido.';
    case 'BP-DR-18':
      return 'Este correo electrónico está deshabilitado en nuestro sistema.';
    case 'BP-DR-21':
      return 'Usted debe tener al menos 16 años.';
    case 'BP-DR-22':
      return 'El documento es requerido.';
    case 'BP-DR-23':
      return 'El documento informado es inválido.';
    case 'BP-DR-24':
      return 'Código Postal es requerido.';
    case 'BP-DR-25':
      return 'Calle es requerido.';
    case 'BP-DR-26':
      return 'Es obligatorio informar el número del domicilio.';
    case 'BP-DR-27':
      return 'El ciudad es requerido.';
    case 'BP-DR-28':
      return 'El estado es requerido.';
    case 'BP-DR-29':
      return 'El estado informado es inválido.';
    case 'BP-DR-31':
      return 'El número de teléfono es requerido.';
    case 'BP-DR-32':
      return 'El número de teléfono informado es inválido.';
    case 'BP-DR-35':
      return 'Hubo un problema con tu pago. Por favor, realiza un nuevo intento o selecciona otro método de pago.';
    case 'BP-DR-38':
      return 'Ha habido un problema con su pago. Por favor, seleccione otro método.';
    case 'BP-DR-39':
      return '¡Ups! Identificamos un problema con tu documento, inténtalo con uno diferente o entra en contacto con nosotros.';
    case 'BP-DR-40':
      return 'Usted alcanzó el límite mensual de pagos.';
    case 'BP-DR-51':
      return '¡Ups!, faltó llenar este campo. Llénalo con el nombre que aparece en tu tarjeta.';
    case 'BP-DR-55':
      return 'El CVV informado es inválido.';
    case 'BP-DR-59':
      return 'Este método de pago no está disponible. Pero no se preocupe, usted todavía puede completar su pago con otro método de pago.';
    case 'BP-DR-67':
      return 'La fecha de caducidad no es válida.';
    case 'BP-DR-75':
      return 'El número de tarjeta informado es inválido.';
    case 'BP-DR-79':
      return 'Lo sentimos, pero este número de cuotas no está permitido para ese pago. Usted puede pagar con más cuotas usando otra tarjeta de crédito.';
    case 'BP-DR-83':
      return 'No procesamos tarjetas emitidas fuera del país. Por favor, utilice otra tarjeta, o seleccione otro método de pago.';
    case 'BP-DR-84':
      return 'Pago duplicado para el mismo cliente con el mismo valor.';
    case 'BP-DR-90':
      return 'Este correo electrónico está bloqueado en nuestro sistema.';
    case 'BP-DR-91':
      return 'Hubo un problema con tu pago. Por favor, realiza un nuevo intento o selecciona otro método de pago.';
    case 'BP-DR-95':
      return '¡Ups! Confirma que hallas llenado este campo con tu nombre y no con otros datos de la tarjeta.';
    case 'BP-DR-97':
      return 'Cuota no está disponible para las tarjetas de prepago.';
    case 'BP-DR-98':
      return 'El cliente asociado a este correo electrónico es de otro país. Utilice otro correo electrónico.';
    case 'BP-DR-100':
      return 'Cuota no está disponible para las tarjetas de débito.';
    case 'BP-DR-101':
      return 'Esta tarjeta no es válida para transacciones en línea.';
    case 'BP-DR-102':
      return 'Ocurrió un problema con tu pago. Por favor, inténtalo nuevamente.';
    case 'BP-DR-103':
      return '¡Ups! No fue posible completar tu transacción. Entra en contacto con EBANX, envía un correo a soporte@ebanx.com para entender lo que pasó.';
    case 'BP-DR-111':
      return 'No logramos validar tu documento. Inténtalo nuevamente más tarde.';
    case 'AR-DB-044':
    case 'AR-DB-075':
      return 'El CUIT es incorrecto. Debes colocar el CUIT del titular de la cuenta.';
    case 'BP-DOC-04':
      return 'Identificamos que su registro está reportado en la Base de Contribuyentes No Confiables de la Agencia de Recaudación y Control Aduanero (ARCA).\
       Debido a esta inclusión, estamos imposibilitados en este momento de ofrecer nuestros servicios de aceptación de pagos con transferencias o tarjetas (débito, crédito, compra o prepagas).\
       Recomendamos que se ponga en contacto con ARCA para regularizar o aclarar su situación. Tan pronto como se confirme su regularización y se actualice el estado en la base de la ARCA,\
       podremos reactivar los servicios.';
    default:
      return undefined;
  }
}
